import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {HelpersService} from '../shared/helpers.service';
import {catchError, shareReplay} from 'rxjs/operators';
import {NotificationService} from '../shared/notification.service';

export interface ITimezone {
  dst: Boolean;
  id: number;
  offset: string;
  order: number;
  timeZoneJavaId: string;
  timeZoneName: string;
}

@Injectable({
  providedIn: 'root',
})
export class TimezonesService {

  private apiUrl = environment.apiUrl;
  private timezonesArray: ITimezone[];

  constructor(
    private http: HttpClient,
    private helpersService: HelpersService,
    private notificationService: NotificationService,
  ) {
  }

  fetchTimezones(): Observable<ITimezone[]> {
    return this.http.get<ITimezone[]>(`${this.apiUrl}timezones`)
      .pipe(
        shareReplay(1),
        catchError(this.helpersService.handleError),
      );
  }

  getTimezonesArray() {
    this.timezonesArray = JSON.parse(localStorage.getItem('timezones'));
    return this.timezonesArray;
  }

  getTimezones() {
    this.fetchTimezones()
    .subscribe(
        (items) => {
          this.timezonesArray = items;
          localStorage.setItem('timezones', JSON.stringify(this.timezonesArray));
        },
        error => this.notificationService.error(error),
      );
  }

  getTimezoneIdFromName(name: string): Number {
    this.timezonesArray = JSON.parse(localStorage.getItem('timezones'));
    return this.timezonesArray.filter(item => item.timeZoneJavaId === name)[0]?.id;
  }

  /**
   * Timezone usable in Moment.js parsing
   */
  getTimezoneJavaIdFromId(id: number): string {
    this.timezonesArray = JSON.parse(localStorage.getItem('timezones'));
    return this.timezonesArray.filter(item => item.id === id)[0]?.timeZoneJavaId;
  }

  /**
   * Timezone usable only to display - not for parsing dates
   */
  getTimezoneNameFromId(id: number): string {
    this.timezonesArray = JSON.parse(localStorage.getItem('timezones'));
    return this.timezonesArray.filter(item => `${item.id}` === `${id}`)[0]?.timeZoneName;
  }

  getTimezoneNameFromJavaId(id: string): string {
    this.timezonesArray = JSON.parse(localStorage.getItem('timezones'));
    return this.timezonesArray.filter(item => item.timeZoneJavaId === id)[0]?.timeZoneName;
  }

  getTimezoneIdFromJavaId(id: string): number {
    this.timezonesArray = JSON.parse(localStorage.getItem('timezones'));
    return this.timezonesArray.filter(item => item.timeZoneJavaId === id)[0]?.id;
  }

  getTimezoneOffsetFromId(id: number): string {
    this.timezonesArray = JSON.parse(localStorage.getItem('timezones'));
    return this.timezonesArray.filter(item => item.id === id)[0]?.offset;
  }


}
